import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
}), 'OpenWithOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/OpenWithOutlined.js
// module id = 5152
// module chunks = 2